import { createReducer } from '@reduxjs/toolkit'
import { preloadedState } from 'store/appState'
import {
  setBalancesLoading,
  setBalancesLoadingReducer,
} from './setBalancesLoadingReducer'
import { setBalances, setBalancesReducer } from './setBalancesReducer'

const balancesReducers = createReducer(preloadedState.balances, builder => {
  builder.addCase(setBalances.type, setBalancesReducer)
  builder.addCase(setBalancesLoading.type, setBalancesLoadingReducer)
})

export default balancesReducers
